import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";
import { fetchEmployeeRequest } from "../../api/employee"
import { getFullName } from "../../helpers/functions/employee"

class EmployeeDetailsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            resource: {
                _id: null,
                company: null,
                firstName: null,
                middleName: null,
                lastName: null,
                employeeType: null,
                employeeNumber: null,
                dateHired: null,
                birthdayDate: null,
                employmentStatus: null,
                dateRegularized: null,
                tinClassification: null,
                tinNumber: null,
                sss: null,
                sssNumber: null,
                phicNumber: null,
                hdmfNumber: null,
                ecolaNumber: null,
                payrollClassification: null,
                payLevel: null,
                superior: null,
                department: null,
                position: null,
                status: null
            }
        }
    }

    componentDidUpdate(prevProps) {
        const { id } = this.props;

        if (id && id !== prevProps.id) {
            this.fetchEmployee(id)
        }
    }

    fetchEmployee = (id) => {
        fetchEmployeeRequest(id, result => this.setState({resource: result}), error => console.log(error))
    }

    render() {
        const { 
            _id,
            company, 
            firstName, 
            middleName, 
            lastName, 
            employeeType, 
            employeeNumber, 
            dateHired, 
            birthdayDate, 
            employmentStatus, 
            dateRegularized, 
            tinClassification, 
            tinNumber, 
            sss, 
            sssNumber, 
            phicNumber, 
            hdmfNumber, 
            ecolaNumber, 
            payrollClassification, 
            payLevel, 
            superior, 
            department, 
            position,
            status
        } = this.state.resource;

        const {
            showModal
        } = this.props;

        return (
            <Modal show={showModal} onHide={this.props.closeModal}>
                <Modal.Header closeButton>
                <Modal.Title>Employee to Approve</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div className="typo-line">
                    <div>
                        <p className="category">Employee ID</p>
                        {_id || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Company</p>
                        {company ? company.companyName : 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">First Name</p>
                        {firstName || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Middle Name</p>
                        {middleName || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Last Name</p>
                        {lastName || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Employee Type</p>
                        {employeeType ? employeeType.employeeTypeName : 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Employee Number</p>
                        {employeeNumber || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Date Hired</p>
                        {dateHired || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Birthday</p>
                        {birthdayDate || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Employment Status</p>
                        {employmentStatus || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Date Regularized</p>
                        {dateRegularized || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">TIN Classification</p>
                        {tinClassification || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">TIN Number</p>
                        {tinNumber || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">SSS</p>
                        {sss || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">SSS Number</p>
                        {sssNumber || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">PHIC Number</p>
                        {phicNumber || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">HDMF Number</p>
                        {hdmfNumber || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">ECOLA Number</p>
                        {ecolaNumber || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Payroll Classification</p>
                        {payrollClassification || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Pay Level</p>
                        {payLevel ? payLevel.level : 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Superior</p>
                        {superior ? getFullName(superior) : 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Department</p>
                        {department ? department.departmentName : 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Position</p>
                        {position ? position.positionName : 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Status</p>
                        {status || 'N/A'}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button 
                      bsStyle="primary" 
                      pullRight 
                      fill 
                      onClick={() => this.props.approveEmployee(_id)}
                    >
                        Approve
                    </Button>
                    <Button 
                      bsStyle="danger" 
                      pullRight 
                      fill
                      style={{
                        marginRight: "10px"
                      }}
                      onClick={() => this.props.rejectEmployee(_id)}
                    >
                        Reject
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default EmployeeDetailsModal;
